import React, { Component } from 'react';
import { Box, Button, Card, Flex, Heading, Text } from 'core/components';
import styled from 'styled-components';
import Markdown from '../../journeys/Markdown';

// reduce some of the margins of headings for tool debug
const ToolMarkdownWrap = styled(Box)`
  h3,
  h4 {
    margin-top: 0;
  }
`;

class DefaultToolResult extends Component {
  render() {
    const { tool, onCloseToolResult, isInlineMode = false } = this.props;
    const { processed_result } = tool;

    let markdownContent = null;
    try {
      if (processed_result) {
        markdownContent = (
          <ToolMarkdownWrap>
            <Markdown>{processed_result}</Markdown>
          </ToolMarkdownWrap>
        );
      }
    } catch (e) {
      markdownContent = null;
    }

    return (
      <Card
        p={0}
        className="tool-result-default"
        display="flex"
        flexDirection="column"
        gap={2}
        height={isInlineMode ? 'auto' : '100%'}
        maxHeight={isInlineMode ? '400px' : undefined}
        overflow="auto"
      >
        <Flex alignItems="center" justifyContent="space-between" p={1} pb={0}>
          <Heading level={isInlineMode ? 6 : 5} m={0} flex={1}>
            {tool.title || 'Tool Result'}
          </Heading>
          <Flex alignItems="center" gap={1}>
            <Button text="Close" small icon="cross" onClick={() => onCloseToolResult(tool)} color="muted" minimal />
          </Flex>
        </Flex>

        <Flex key={tool.id || tool.tool_tracking_id} flexDirection="column" gap={2} p={1}>
          {markdownContent || <Text>Tool result not implemented for tool: {tool.tool_name}</Text>}
        </Flex>
      </Card>
    );
  }
}

export default DefaultToolResult;
